import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Card } from 'semantic-ui-react'

import * as experimentsActions from '../../actions/actionsExperiments';

const style = {
  card: {
    width: 'auto',
    meta: {
      marginTop: '.5em'
    }
  }
}

class BeatCard extends Component {
  render() {
    const { name, description } = this.props;

    return (
      <Card style={style.card}>
        <Card.Content>
          <Card.Header>{name}</Card.Header>
          <Card.Meta style={style.card.meta}>{description}</Card.Meta>
          <Card.Description>
            
          </Card.Description>
        </Card.Content>
      </Card>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    experiments: state.experiments
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(experimentsActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BeatCard);



// WEBPACK FOOTER //
// ./src/components/experiments/BeatCard.js